"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EDemembrementTypeTrads = void 0;
exports.EDemembrementTypeTrads = {
    temporaire: "Temporaire",
    viager: "Viager",
};
